export default (params) => ({
  trigger: {
    name: 'product_type_section.select_choose_alternative',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_list_id: {
        type: 'integer',
      },
      item_list_name: {
        type: 'string',
      },
      number_of_items: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item_list',
      params: {
        sub_feature: null,
      },
    },
  },
});
